import { IComplaint } from '../../../../api/complaint';
import { isArrayWithItems } from '../../../../utils';

export const  getSelectedComplaint = (
  complaints: IComplaint[] | null,
  selectionTree: number[],
): IComplaint | undefined => {
  let selectedComplaint: IComplaint | undefined;

  if (!isArrayWithItems(complaints)) {
    return undefined;
  }

  selectionTree.forEach(complaintIndex => {
    selectedComplaint = selectedComplaint && selectedComplaint.items[complaintIndex] || complaints[complaintIndex];
  });

  return selectedComplaint;
};
